const styles = () => ({
  root: {
    width: "100%",
    overflow: "auto",

    // extra padding to avoid cutting focus rings in the last line
    paddingBottom: 3,
  },
});

export default styles;
